import React from 'react';
import { useTranslate } from '@/translations';
import { PageContainer, faCalendarDays, Title } from '@/ui/components';
import { Card } from 'antd';
import { AdminShippingPlanDataGrid } from './components/ShippingPlanDataGrid';

export const AdminShippingPlan = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('shippingPlanAdmin')} icon={faCalendarDays} />

      <Card>
        <AdminShippingPlanDataGrid />
      </Card>
    </PageContainer>
  );
};
